// This Userkit of mstage tool will help us to collect user's related data such as:
// Platform information, Profile_ID, ...
// And also send event to event tracking service as well
const { detect } = require('detect-browser');
const cookie = require('./utils/cookie')
const { eventCorrector } = require('./utils/event.corrector')
const browser = detect()


module.exports = function (window) {
  var messagesRef = '',
    database
  var version = 'v1'
  let EventTrackingConfig = {
    token: 'iamarandomshopbacktesttoken',
    eventTrackingUrl: '//tracking.shopback.com/',
  }
  var streamingData = {}
  var defaultProp = {}
  var allowedProfileIDType = ['string', 'number']
  let streamingEvent = {
    STREAM_PLAYING: '_stream_playing',
    STREAM_BUFFER: '_stream_buffer',
    STREAM_LICENSE_RETRIEVED: '_stream_license_retrieved',
  }
  var streamingProperty = {
    TRANSFER_DURATION: '_transfer_duration',
    NUMBER_OF_BYTES_TRANSFERRED: '_number_of_bytes_transferred',
    OBSERVED_BITRATE: '_observed_bitrate',
    AVERAGE_AUDIO_BITRATE: '_average_audio_bitrate',
    AVERAGE_VIDEO_BITRATE: '_average_video_bitrate',
    STARTUP_TIME: '_starup_time',
    DURATION_WATCHED: '_duration_watched',
    NUMBER_OF_DROPPED_VIDEO_FRAMES: '_number_of_dropped_video_frames',
    NUMBER_OF_STALLS: '_number_of_stalls',
  }
  var trackerReady = false

  createProfileId()

  function createProfileId() {
    if (!cookie.read('profileID')) {
      var profileID = generateProfileID()
      cookie.write('profileID', profileID, 730)
      cookie.write(profileID, true, 730)
    }
  }

  function checkCookie(domain) {
    try {
      // Create cookie
      document.cookie = 'cookietest=1' + (domain ? '; domain=' + domain : '')
      var ret = document.cookie.indexOf('cookietest=') != -1
      // Delete cookie
      document.cookie =
        'cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT' +
        (domain ? '; domain=' + domain : '')
      return ret
    } catch (e) {
      return false
    }
  }

  function checkLocalStorage() {
    var mod = 'modernizr'
    try {
      localStorage.setItem(mod, mod)
      localStorage.removeItem(mod)
      return true
    } catch (e) {
      return false
    }
  }

  function makeRequest(url, data, method, callback) {
    const trackingEnvironment =
      typeof window !== 'undefined'
        ? window.BOOTSTRAP_DATA && window.BOOTSTRAP_DATA.trackingEnvironment
        : 'PROD'
    if (EventTrackingConfig.token) {
      var request = new XMLHttpRequest()
      request.onreadystatechange = function () {
        if (
          request.readyState === 4 &&
          callback &&
          typeof callback === 'function'
        ) {
          var data = request.responseText
          if (data && typeof data === 'string') {
            data = JSON.parse(data)
          } else {
            data = {}
          }
          callback({status: request.status, data: data})
        }
      }
      request.open(method, url, true)
      request.setRequestHeader('Content-Type', 'application/json')
      request.setRequestHeader('X-Shopback-Environment', trackingEnvironment)
      request.send(data)
    }
  }

  function generateProfileID() {
    var text = 'web_'
    var possible =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    for (var i = 0; i < 32; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length))
    }
    text += '_' + new Date().getTime()
    return text
  }

  function mergeObject(obj1, obj2) {
    var obj3 = {}
    for (var attrname in obj1) {
      obj3[attrname] = obj1[attrname]
    }
    for (var attrname in obj2) {
      obj3[attrname] = obj2[attrname]
    }
    return obj3
  }

  function parseJWT(token) {
    var base64Url = token.split('.')[1]
    var base64 = base64Url.replace('-', '+').replace('_', '/')
    return JSON.parse(window.atob(base64))
  }

  function getBrowserInfo() {
    try {
      const majorVersion = browser.version.split('.')[0]
      return {
        name: browser.name,
        version: majorVersion,
      }
    } catch (err) {
      console.error('Getting Browser infor error: ', err)
      return {
        name: null,
        version: 'unkonwn',
      }
    }
  }

  function objectAddPrefix(obj) {
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (key.charAt(0) !== '_') {
          obj['_' + key] = obj[key]
          delete obj[key]
        }
      }
    }
    return obj
  }

  // window.EventTracker
  return {
    isTrackerReady: function () {
      return trackerReady
    },
    init (customConfig) {
            if (customConfig && typeof customConfig === 'object') {
                EventTrackingConfig = mergeObject(EventTrackingConfig, customConfig);
            }
            var EventTracker_defaultInfo = cookie.read('EventTracker_defaultInfo');
            var EventTracker_defaultInfo_notAvailable = !EventTracker_defaultInfo || typeof EventTracker_defaultInfo !== 'string';
            var EventTracker_defaultProp = cookie.read('EventTracker_defaultProp');
            var EventTracker_defaultProp_notAvailable = !EventTracker_defaultProp || typeof EventTracker_defaultProp !== 'string';

            if (!EventTracker_defaultInfo_notAvailable) {
              try {
                EventTracker_defaultInfo = JSON.parse(EventTracker_defaultInfo);
              } catch {
                EventTracker_defaultInfo_notAvailable = true;
              }
            }

            if (!EventTracker_defaultProp_notAvailable) {
              try {
                EventTracker_defaultProp = JSON.parse(EventTracker_defaultProp);
              } catch {
                EventTracker_defaultProp_notAvailable = true;
              }
            }

          this.getProfileId();
          trackerReady = true;
        },

    alias (profileID, aliasID, callback) {
          var localProfileID = cookie.read('profileID');
          if (localProfileID && allowedProfileIDType.indexOf(typeof localProfileID) > -1 && profileID && allowedProfileIDType.indexOf(typeof profileID) > -1) {
            var data = {
                profile_id: localProfileID,
                alias_id: profileID
            };
            if (aliasID && allowedProfileIDType.indexOf(typeof aliasID) > -1) {
                data = {
                    profile_id: profileID,
                    alias_id: aliasID
                };
            }

            if (data.profile_id !== data.alias_id) {
                makeRequest(EventTrackingConfig.eventTrackingUrl  + 'client/' + version + '/aliases', JSON.stringify(data), 'POST', callback);
            }
          } else {
            console.trace('Error in EventTracker.alias: Invalid profile id')
          }
        },

    getProfileId: function () {
          var profileID = cookie.read('profileID');
          if (profileID) {
            return profileID;
          }
            createProfileId();

            return cookie.read('profileID');

        },

    isLocalProfile () {
            var profileID = cookie.read('profileID');
            var isLocalProfile = cookie.read(profileID);
            return isLocalProfile || true;
        },

    createNewProfile: function (profileID, properties, callback) {
      if (profileID && allowedProfileIDType.indexOf(typeof profileID) > -1) {
        if (!properties || typeof properties !== 'object') {
          properties = {}
        }
        let data = {
          profile_id: profileID,
          properties: properties,
        }
        makeRequest(
          EventTrackingConfig.eventTrackingUrl +
            'client/' +
            version +
            '/profile',
          JSON.stringify(data),
          'POST',
          () => {
            cookie.write('profileID', profileID, 730)
            cookie.write(profileID, false, 730)
            if (callback && typeof callback === 'function') {
              callback()
            } else {
              console.trace('Created profile successfully!')
            }
          },
        )
      } else {
        console.trace(
          'Error in EventTracker.createNewProfile: Invalid profile id',
        )
      }
    },

    identify: function (profileID) {
      if (profileID && allowedProfileIDType.indexOf(typeof profileID) > -1) {
        cookie.write('profileID', profileID, 730)
      } else {
        console.trace('Error in EventTracker.identify: Invalid profile id')
      }
    },

    track: function (eventName, properties, callback) {
      var profileID = cookie.read('profileID')
      if (profileID) {
        var [error, correctedProperties] = eventCorrector(properties)
        if (!error) {
          if (!correctedProperties || typeof correctedProperties !== 'object') {
            correctedProperties = {}
          }
          var defaultProp = cookie.read('EventTracker_defaultProp')
          if (defaultProp && typeof defaultProp === 'string') {
            defaultProp = JSON.parse(defaultProp)
          } else {
            defaultProp = {}
          }
          var mergedProp = mergeObject(defaultProp, correctedProperties)
          let data = {
            profile_id: profileID,
            name: eventName,
            properties: mergedProp,
          }
          makeRequest(
            EventTrackingConfig.eventTrackingUrl +
              'client/' +
              version +
              '/events',
            JSON.stringify(data),
            'POST',
            callback,
          )
        } else {
          console.trace(
            'Error in EventTracker.track: Specific event does not have required property or have wrong properties. Please check again!',
          )
        }
      } else {
        console.trace('Error in EventTracker.track: Invalid profile id')
      }
    },

    bulkTrack (events, callback) {
          var profileID = cookie.read('profileID');
          if (profileID && events.constructor === Array) {
            var isValid = true;
            events.forEach(function (e) {
              var defaultProp = cookie.read('EventTracker_defaultProp');
              if (defaultProp && typeof defaultProp === 'string') {
                defaultProp = JSON.parse(defaultProp);
              } else {
                defaultProp = {};
              }
              e.properties = mergeObject(defaultProp, e.properties);
              var [error, correctedProperties] = eventCorrector(e.properties);
              if (error) {
                isValid = false;
              } else {
                e.properties = correctedProperties
              }
            });

            if (isValid) {
              var data = {
                profile_id: profileID,
                events: events
              };
              makeRequest( EventTrackingConfig.eventTrackingUrl + 'client/' + version + '/events/bulk', JSON.stringify(data), 'POST', callback);
            } else {
              console.trace('Error in EventTracker.bulkTrack: Some of specific events does not include required properties. Please check again!');
            }
          } else {
            console.trace('Error in EventTracker.bulkTrack: Profile ID or Events are invalid')
          }
        },

    profile: {
      set: function (properties, callback) {
        var profileID = cookie.read('profileID')
        if (profileID) {
          if (!properties || typeof properties !== 'object') {
            properties = {}
          }
          var data = {
            profile_id: profileID,
            properties: properties,
          }
          makeRequest(
            EventTrackingConfig.eventTrackingUrl +
              'client/' +
              version +
              '/profile',
            JSON.stringify(data),
            'POST',
            callback,
          )
        } else {
          console.trace('Error in EventTracker.profile.set: Invalid profile id')
        }
      },

      setOnce (properties, callback) {
                var profileID = cookie.read('profileID');
                if (profileID) {
                    if (properties && typeof properties === 'object') {
                      var data = {
                          profile_id: profileID,
                          properties: properties
                      };
                      makeRequest( EventTrackingConfig.eventTrackingUrl + 'client/' + version + '/profile/set_once', JSON.stringify(data), 'PUT', callback);
                    }
                } else {
                  console.trace('Error in EventTracker.profile.setOnce: Invalid profile id')
                }
            },

      increase: function (param, number, callback) {
        var profileID = cookie.read('profileID')
        if (profileID) {
          if (typeof param === 'object' && !number) {
            // Passing a object
            var data = {
              profile_id: profileID,
              properties: param,
            }
            makeRequest(
              EventTrackingConfig.eventTrackingUrl +
                'client/' +
                version +
                '/profile/increase',
              JSON.stringify(data),
              'PUT',
              callback,
            )
          } else if (typeof param === 'string') {
            // Passing a single property
            var number = number || 1;
                            var properties = {};
            properties[param] = number
            var data = {
              profile_id: profileID,
              properties: properties,
            }
            makeRequest(
              EventTrackingConfig.eventTrackingUrl +
                'client/' +
                version +
                '/profile/increase',
              JSON.stringify(data),
              'PUT',
              callback,
            )
          }
        } else {
          console.trace(
            'Error in EventTracker.profile.increment: Invalid profile id',
          )
        }
      },

      append: function (param, value, callback) {
        var profileID = cookie.read('profileID')
        if (profileID) {
          if (typeof param === 'object' && !value) {
            var data = {
              profile_id: profileID,
              properties: param,
            }
            makeRequest(
              EventTrackingConfig.eventTrackingUrl +
                'client/' +
                version +
                '/profile/append',
              JSON.stringify(data),
              'PUT',
              callback,
            )
          } else if (typeof param === 'string' && value) {
            var properties = {}
            properties[param] = value
            var data = {
              profile_id: profileID,
              properties: properties,
            }
            makeRequest(
              EventTrackingConfig.eventTrackingUrl +
                'client/' +
                version +
                '/profile/append',
              JSON.stringify(data),
              'PUT',
              callback,
            )
          }
        } else {
          console.trace(
            'Error in EventTracker.profile.append: Invalid profile id',
          )
        }
      },

      union: function (param, value, callback) {
        var profileID = cookie.read('profileID')
        if (profileID) {
          if (typeof param === 'object' && !value) {
            var data = {
              profile_id: profileID,
              properties: param,
            }
            makeRequest(
              EventTrackingConfig.eventTrackingUrl +
                'client/' +
                version +
                '/profile/union',
              JSON.stringify(data),
              'PUT',
              callback,
            )
          } else if (typeof param === 'string' && value) {
            var properties = {}
            properties[param] = value
            var data = {
              profile_id: profileID,
              properties: properties,
            }
            makeRequest(
              EventTrackingConfig.eventTrackingUrl +
                'client/' +
                version +
                '/profile/union',
              JSON.stringify(data),
              'PUT',
              callback,
            )
          }
        } else {
          console.trace(
            'Error in EventTracker.profile.union: Invalid profile id',
          )
        }
      },

      getProperty (key, callback) {
                var profileID = cookie.read('profileID');
                if (profileID && key && typeof callback === 'function') {
                    makeRequest(EventTrackingConfig.eventTrackingUrl +  'client/' + version + '/profile/property?profile_id=' + profileID + '&key=' + key, null, 'GET', callback);
                } else {
                  console.trace('Error in EventTracker.profile.getProperty: Invalid profile id or callback')
                }
            },

      getProperties: function (keys, callback) {
        var profileID = cookie.read('profileID')
        if (profileID && keys && typeof callback === 'function') {
          makeRequest(
            EventTrackingConfig.eventTrackingUrl +
              'client/' +
              version +
              '/profile/properties?profile_id=' +
              profileID +
              '&keys=' +
              keys,
            null,
            'GET',
            callback,
          )
        } else {
          console.trace(
            'Error in EventTracker.profile.getProperties: Invalid profile id or callback',
          )
        }
      },

      arraySearch (key, query, callback) {
              var profileID = cookie.read('profileID');
              if (profileID && typeof key === 'string') {
                var data = {
                    profile_id: profileID,
                    key: key,
                    query: query
                };
                makeRequest( EventTrackingConfig.eventTrackingUrl + 'client/' + version + '/profile/array/search', JSON.stringify(data), 'POST', callback);
              } else {
                console.trace('Error in in EventTracker.profile.arraySearch: Invalid profile id or key')
              }
            },

      arrayRemove (key, query, callback) {
              var profileID = cookie.read('profileID');
              if (profileID && typeof key === 'string') {
                  var data = {
                      profile_id: profileID,
                      key: key,
                      query: query
                  };
                  makeRequest( EventTrackingConfig.eventTrackingUrl + 'client/' + version + '/profile/array/remove', JSON.stringify(data), 'POST', callback);
              } else {
                console.trace('Error in EventTracker.profile.arrayRemove: Invalid profile id or key')
              }
            },

      originalId (profileID, callback) {
              if (profileID) {
                makeRequest(EventTrackingConfig. eventTrackingUrl + 'client/' + version + '/profile/original_id?profile_id=' + profileID, null, 'GET', callback);
              } else {
                console.trace('Error in EventTracker.profile.originalId: Invalid profile id');
              }
            }
      },

    streamAnalytic: {
      time: function (eventName) {
        var streamingData = cookie.read('EventTracker_streamingData')
        if (streamingData) {
          if (typeof streamingData === 'string') {
            streamingData = JSON.parse(streamingData)
          } else {
            streamingData = {}
          }
          if (eventName in streamingEvent) {
            var data = streamingData
            data['_duration'] = new Date().getTime()
            cookie.write(streamingEvent[eventName], JSON.stringify(data), 730)
          } else {
            console.trace(
              'Error in EventTracker.streamAnalytic.track: Event name does not support!',
            )
          }
        } else {
          console.trace('You need to call the init function first!')
        }
      },

      track (eventName, callback) {
                var streamingData = cookie.read('EventTracker_streamingData');
                if (streamingData) {
                    if (typeof streamingData === 'string') {
                      streamingData = JSON.parse(streamingData);
                    } else {
                      streamingData = {};
                    }
                    var profileID = cookie.read('profileID');
                    if (profileID) {
                        if (eventName in streamingEvent) {
                            var event = cookie.read(streamingEvent[eventName]);
                            if (event && typeof event === 'string') {
                                event = JSON.parse(event);
                            }
                            if (!event || typeof event !== 'object') {
                                console.trace('Error in streamAnalytic.track: Event does not exist');
                            } else {
                                event['_duration'] = new Date().getTime() - event['_duration'];
                                var defaultProp = cookie.read('EventTracker_defaultProp');
                                if (defaultProp && typeof defaultProp === 'string') {
                                    defaultProp = JSON.parse(defaultProp);
                                } else {
                                    defaultProp = {};
                                }
                                var mergedProp = mergeObject(defaultProp, event);
                                var data = {
                                    profileID: profileID,
                                    name: streamingEvent[eventName],
                                    properties: mergedProp
                                };
                                makeRequest( EventTrackingConfig.eventTrackingUrl + 'client/' + version + '/events', JSON.stringify(data), 'POST', callback);
                            }
                        } else {
                            console.trace('Error in EventTracker.streamAnalytic.track: Event name does not support!');
                        }
                    } else {
                      console.trace('Error in EventTracker.streamAnalytic.track: Invalid profile id')
                    }
                } else {
                    console.trace('You need to call the init function first!');
                }
            },

      set (eventName, propertyName, value) {
                var streamingData = cookie.read('EventTracker_streamingData');
                if (streamingData) {
                    if (typeof streamingData === 'string') {
                      streamingData = JSON.parse(streamingData);
                    } else {
                      streamingData = {};
                    }
                    if (eventName in streamingEvent) {
                        var event = cookie.read(streamingEvent[eventName]);
                        if (event && typeof event === 'string') {
                            event = JSON.parse(event);
                        }
                        if (!event || typeof event !== 'object') {
                            console.trace('Error in EventTracker.streamAnalytic.set: Event does not exist');
                        } else {
                            if (propertyName in streamingProperty) {
                                if (propertyName === 'NUMBER_OF_BYTES_TRANSFERRED'){
                                  value = (value / 1000000) * 8;
                                } else if (propertyName === 'OBSERVED_BITRATE' || propertyName === 'AVERAGE_AUDIO_BITRATE' || propertyName === 'AVERAGE_VIDEO_BITRATE'){
                                  value = value / 1000000;
                                }
                                event[streamingProperty[propertyName]] = value;
                                cookie.write(streamingEvent[eventName], JSON.stringify(event), 730);
                            } else {
                                console.trace('Error in EventTracker.streamAnalytic.set: Property name does not support!');
                            }
                        }
                    } else {
                        console.trace('Error in EventTracker.streamAnalytic.set: Event name does not support!');
                    }
                } else {
                    console.trace('You need to call the init function first!');
                }
            }
    },

    getLocationInfo () {
          var EventTracker_defaultInfo = cookie.read('EventTracker_defaultInfo');
          if (EventTracker_defaultInfo && typeof EventTracker_defaultInfo === 'string') {
            EventTracker_defaultInfo = JSON.parse(EventTracker_defaultInfo);
          } else {
            EventTracker_defaultInfo = {
              country: ''
            };
          }

          return EventTracker_defaultInfo.country;
        }

  }
}
